export enum SpinKitType {
    Plane = 'plane',
    Chase = 'chase',
    Bounce = 'bounce',
    Wave = 'wave',
    Pulse = 'pulse',
    Swing = 'swing',
    Circle = 'circle',
    CircleFade = 'circle-fade',
    Grid = 'grid',
    Fold = 'fold'
}

/**
 * @description Union type for spinner type that accepts both enum values and string literals
 * @type ISpinKitType
 * @example
 * ```typescript
 * const type: ISpinKitType = 'plane';
 * const type: ISpinKitType = SpinKitType.Plane;
 * ```
 */
export type ISpinKitType = SpinKitType | 'plane' | 'chase' | 'bounce' | 'wave' | 'pulse' | 'swing' | 'circle' | 'circle-fade' | 'grid' | 'fold';
